<template>
  <div class="container">
    <div class="mySite-container">
      <div class="mySite-section">
        <header class="mySite-header">
          <p class="mySite-header-title">收货地址</p>
          <div class="mySite-header-handle">
            <router-link :to="{ name: 'new_addres' }"
              ><el-button size="mini" type="text" class="mySite-header-button"
                >新增收货地址</el-button
              ></router-link
            >
            <el-button
              size="mini"
              @click="$router.go(-1)"
              type="text"
              class="mySite-header-button"
              >返回</el-button
            >
          </div>
        </header>
        <div class="mySite-body">
          <template>
            <el-table
              border
              :data="addressList"
              style="width: 100%"
              v-loading="loading"
            >
              <el-table-column prop="name" label="收货人" width="120">
              </el-table-column>
              <el-table-column prop="address" label="收货地址">
              </el-table-column>
              <el-table-column prop="phone" label="联系电话" width="120">
              </el-table-column>
              <el-table-column label="默认地址" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_default === false">否</span>
                  <span v-if="scope.row.is_default === true">是</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作" width="90">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      name: 'new_editres',
                      params: { id: scope.row.id }
                    }"
                  >
                    <el-button size="mini" type="text">编辑</el-button>
                  </router-link>
                  <el-divider direction="vertical"></el-divider>
                  <el-button
                    size="mini"
                    type="text"
                    @click="handleDelete(scope.row.id, scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import giftService from "@/global/service/gift";
export default {
  data() {
    return {
      addressList: [],
      pageSize: 10,
      pageCount: null,
      total: null,
      currentPage: 1,
      loading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      giftService
        .addressList()
        .then(res => {
          this.addressList = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDelete(id, index) {
      this.$confirm("确认删除该地址？")
        .then(() => {
          giftService.addressDelete(id).then(() => {
            this.$message.success("删除成功");
            this.addressList.splice(index, 1);
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.mySite-section {
  background-color: #fff;
  .mySite-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #dedede;
    font-size: 12px;
    color: #2c3e50;
    font-weight: 300;
    .el-button {
      background-color: #fff;
      color: #f0b32f;
      margin: 0 10px;
    }
  }
  .mySite-body {
    padding: 20px;
  }
}
.page-pagination {
  margin-top: 30px;
}
</style>
